import { render, staticRenderFns } from "./fvlDialogBox.vue?vue&type=template&id=537dc818&scoped=true&"
import script from "./fvlDialogBox.vue?vue&type=script&lang=js&"
export * from "./fvlDialogBox.vue?vue&type=script&lang=js&"
import style0 from "./fvlDialogBox.vue?vue&type=style&index=0&id=537dc818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dc818",
  null
  
)

export default component.exports